/* eslint-disable @typescript-eslint/no-explicit-any */
import { Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Font-end
import { PageNotFound } from "./pages/404Page";
import { PageLayout } from "./components/PageLayout";

//Check Time Login
import IdleTimeOutHandler from "./components/IdleTimeOutHandler";

//Backoffice


import { Authen } from "./pages/backend/Authen";
import Protected from "./Protected";
import {
  getUserSalaryGroup,
  getUserConsentGroup,
} from "./services/PermissionGroup";
import { UseDesktop } from "./pages/backend/useDesktop";
import { Consent } from "./pages/backend/Consent";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { ConsentPage } from "./pages/ConsentPage";

import withClearCache from "./ClearCache";
import { getInfoUsers } from "./services/ApiGetUserInfo";

const Pages = (props: any) => {
  const [needsConsent, setNeedsConsent] = useState<boolean | null>(null); // null = checking, false = no consent needed, true = consent needed
  const [isLoading, setIsLoading] = useState(true);

  // Asynchronous consent checking
  useEffect(() => {
    const checkConsentAsync = async () => {
      try {
        setIsLoading(true);
        
        // Check if user is on admin panel
        const adminUris = ["admconsent"];
        const isAdminPanel = adminUris.some((uri) =>
          window.location.pathname.includes(`/${uri}`)
        );

        if (isAdminPanel) {
          setNeedsConsent(false);
          setIsLoading(false);
          return;
        }

        //         const infoUser = await getInfoUsers();
        // const userPurposesAgreement = await GetUserConsent({
        //   idOrEmail: infoUser?.email,
        // });
        // const activePurposesRes = (await GetOneTrustPurposesById()) || [];
        // const userPurposes = userPurposesAgreement?.content[0]?.Purposes || [];

        // const matchedPurposes = [];
        // let hasNewVersion = false;

        // for (const apr of activePurposesRes) {
        //   const matchedPurpose = userPurposes?.find(
        //     (up: any) => apr?.purposeId === up?.Id
        //   );

        //   matchedPurpose && matchedPurposes.push(matchedPurpose);
        // }

        // for (const apr of activePurposesRes) {
        //   hasNewVersion = userPurposes?.some(
        //     (up: any) =>
        //       apr?.purposeId === up?.Id && apr?.version !== up?.Version
        //   );

        //   if (hasNewVersion) {
        //     break;
        //   }
        // }

        // const hasNewPurpose =
        //   activePurposesRes?.length !== matchedPurposes?.length ? true : false;

        // if (!userPurposes?.length || hasNewPurpose || hasNewVersion) {
        //   setNeedsConsent(true);
        // }


        // For regular users, show ConsentPage immediately
        console.log('Delegating consent check to ConsentPage');
        setNeedsConsent(true);
        setIsLoading(false);

      } catch (error) {
        console.error('Error during consent check:', error);
        setNeedsConsent(true); // Default to showing consent page on error
        setIsLoading(false);
      }
    };

    checkConsentAsync();
  }, []); // Remove infoUsers dependency for cleaner async flow

  if (isLoading) {
    return (
      <div className="layout-loading">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }

  // Show consent page if user needs to give consent
  if (needsConsent === true) {
    return <ConsentPage />;
  }

  return (
    <>
      <Routes>
          <Route path="/" element={<ConsentPage />} />
          <Route
            path="/desktop-olny"
            element={
              <Protected isAdmin={props.isAdmin} role="backoffice">
                <UseDesktop />
              </Protected>
            }
          />
          <Route
            path="/admconsent"
            element={
              <Protected isAdmin={props.isAdmin} role="consent">
                <Consent />
              </Protected>
            }
          />
          <Route
            path="/admconsent/manage-consent"
            element={
              <Protected isAdmin={props.isAdmin} role="consent">
                <Consent />
              </Protected>
            }
          />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/auth/:role" element={<Authen />} />
        </Routes>
    </>
  );
};
const Login = () => {
  const { instance } = useMsal();
  localStorage.clear();
  instance.loginRedirect(loginRequest).catch((e) => {
    //console.log('login xxxx=>', e)
  });
  return (
    <>
      <div className="layout-loading">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
};

function App() {
  return (
    <>
      <ClearCacheComponent />
      <ToastContainer />
    </>
  );
}

const MainApp = () => {
  // console.log("apiEnpoint ===> ", process.env.REACT_APP_API_SCOPE)
  const [isAdmin, setIsAdmin] = useState(false);
  
  useEffect(() => {
    if (localStorage.getItem("Language") === null) {
      localStorage.setItem("Language", "th");
    }

    const hostname: string = window.location.pathname;
    if (hostname.includes("admconsent")) {
      getUserConsentGroup().then(async (resp: any) => {
        setIsAdmin(resp);
      });
    } else {
      getUserSalaryGroup().then(async (resp: any) => {
        setIsAdmin(resp);
      });
    }
  }, []);

  // Idle timeout state management
  const [, setIsActive] = useState(true);
  const [, setLogout] = useState(false);

  if (process.env.REACT_APP_ENV === "test") {
    return (
      <>
        <PageLayout>
          <Pages isAdmin={isAdmin} />
        </PageLayout>
      </>
    );
  }

  return (
    <>
      <AuthenticatedTemplate>
        <PageLayout>
          <IdleTimeOutHandler
            onActive={() => {
              setIsActive(true);
            }}
            onIdle={() => {
              setIsActive(false);
            }}
            onLogout={() => {
              setLogout(true);
            }}
            timeOutInterval={process.env.REACT_APP_TIMEOUT_LOGIN} //10 minute
          />
          <Pages isAdmin={isAdmin} />
        </PageLayout>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

const ClearCacheComponent = withClearCache(MainApp);
export default App;
